import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/icons/edit.png';
import _imports_1 from '@/assets/icons/delete.png';
import _imports_2 from '@/assets/icons/drag.png';
const _hoisted_1 = {
    class: "rounded-1 p-3 mt-3 position-relative",
    style: { "background-color": "var(--neutrali-grigio-chiarissimo, #FAFAFA)" }
};
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-2" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "text-muted small" };
const _hoisted_6 = { class: "d-flex flex-row align-items-center" };
const _hoisted_7 = { class: "d-flex flex-row flex-1 align-items-center gap-24px" };
const _hoisted_8 = { class: "d-flex flex-row align-items-center gap-12px" };
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = { class: "museum-name-list" };
const _hoisted_11 = { class: "d-flex align-items-center gap-12px" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
import { onMounted, ref } from "vue";
import { openModal, closeModal } from "jenesius-vue-modal";
import { useToast } from 'vue-toast-notification';
import ButtonComponent from '../components/Button.vue';
import OfferModal from "./OfferModal.vue";
import DeleteOfferModal from "./DeleteModal.vue";
import StatusComponent from "../components/Status.vue";
import draggable from "vuedraggable";
import Loading from 'vue-loading-overlay';
import axios from "axios";
import 'vue-loading-overlay/dist/css/index.css';
import 'vue-toast-notification/dist/theme-sugar.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferList',
    props: {
        baseUrl: { type: String },
        token: { type: String },
        languageJson: { type: Array },
        campaignId: { type: String }
    },
    emits: ['onOffersOrderChange', 'hideImgUpload'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const $toast = useToast();
        const offers = ref([]);
        const preOffers = ref([]);
        const getError = ref(null);
        const isLoading = ref(false);
        const handleEditOfferModal = async (offer) => {
            const modalProps = {
                baseUrl: props.baseUrl,
                languageJson: props.languageJson,
                campaignId: props.campaignId,
                edit: true,
                offerId: offer.uuid
            };
            emit('hideImgUpload');
            const modal = await openModal(OfferModal, modalProps);
            modal.on('return', () => {
                fetchOffers();
            });
            modal.on('hideImgUpload', () => {
                emit('hideImgUpload');
            });
        };
        // Modale per conferma di cancellazione
        async function openModalDeleteOffer(offer) {
            const modal = await openModal(DeleteOfferModal, {
                modalTitle: 'Cancellazione Offerta',
                modalContent: 'Sicuro di voler rimuovere l\'offerta <b>\'' + offer.name + '\'</b> ?',
            });
            modal.on('ModalConfirm', async () => {
                isLoading.value = true;
                await handleDelete(offer.uuid);
                await fetchOffers();
                isLoading.value = false;
            });
        }
        // Funzione per CANCELLARE un'offerta
        const handleDelete = async (uuid) => {
            try {
                await axios
                    .delete(`${props.baseUrl}/v1/private/offers/${uuid}`, {
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                $toast.success("Offerta eliminata con successo", { position: 'top' });
            }
            catch (error) {
                $toast.error(error.response.data.title, { position: 'top' });
            }
            finally {
                closeModal();
            }
        };
        // Funzione per AGGIUNGERE un'offerta
        const handleAddActivityModal = async () => {
            const modalProps = {
                baseUrl: props.baseUrl,
                languageJson: props.languageJson,
                campaignId: props.campaignId,
                edit: false
            };
            emit('hideImgUpload');
            const modal = await openModal(OfferModal, modalProps);
            modal.on('return', () => {
                fetchOffers();
            });
            modal.on('hideImgUpload', () => {
                emit('hideImgUpload');
            });
        };
        const onChange = () => {
            emit('onOffersOrderChange', offers.value);
        };
        const fetchOffers = async () => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(`${props.baseUrl}/v1/private/offers`, {
                    headers: {
                        Authorization: `Bearer ${props.token}`
                    }
                });
                preOffers.value = response.data?.results;
                console.log('offers', preOffers.value);
                offers.value = preOffers.value.filter(offer => offer.campaign.uuid === props.campaignId);
                console.log('offers filtered', offers.value);
            }
            catch (error) {
                console.error("Lodating offers error", error);
                //getError.value = error;
            }
            finally {
                isLoading.value = false;
            }
        };
        function hideImgUpload() {
            emit('hideImgUpload');
        }
        onMounted(() => {
            fetchOffers();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("h6", { class: "fs-3 mb-0 d-flex flex-column align-self-end title-form" }, "Offerte", -1)),
                    _createVNode(ButtonComponent, {
                        text: "Aggiungi Offerta",
                        type: "regular",
                        class: "bg-white",
                        isDisable: isLoading.value,
                        onClick: handleAddActivityModal,
                        onHideImgUpload: hideImgUpload
                    }, null, 8, ["isDisable"])
                ]),
                _createVNode(_unref(Loading), {
                    active: isLoading.value,
                    "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((isLoading).value = $event)),
                    "can-cancel": false,
                    "is-full-page": false,
                    color: "#2D489D",
                    loader: "dots"
                }, null, 8, ["active"]),
                (getError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(getError.value), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(offers.value.length > 0
                            ? 'Trascina le offerte per cambiare ordine di visualizzazione'
                            : 'Nessuna offerta presente'), 1),
                        (offers.value.length > 0)
                            ? (_openBlock(), _createBlock(_unref(draggable), {
                                key: 0,
                                tag: "ul",
                                list: offers.value,
                                class: "d-flex flex-column mt-1 p-3 gap-16px bg-musemu-list",
                                handle: ".handle",
                                "item-key": "uuid",
                                onChange: onChange
                            }, {
                                item: _withCtx(({ element, index }) => [
                                    _createElementVNode("li", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", null, _toDisplayString(index + 1) + ".", 1),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("img", {
                                                    class: "musuem-avatar",
                                                    src: element.images[0]?.thumb,
                                                    alt: element.images[0]?.alt
                                                }, null, 8, _hoisted_9),
                                                _createElementVNode("div", _hoisted_10, _toDisplayString(element.name), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createVNode(StatusComponent, {
                                                text: element.status?.id === 1 ? 'PUBLISHED' : 'DRAFT',
                                                type: element.status?.id === 1 ? 'primary' : 'disable'
                                            }, null, 8, ["text", "type"]),
                                            _createElementVNode("i", {
                                                class: "handle drag-img",
                                                style: { "cursor": "pointer" },
                                                role: "button",
                                                tabindex: "0",
                                                title: "Modifica",
                                                onClick: ($event) => (handleEditOfferModal(element))
                                            }, [
                                                _createElementVNode("img", {
                                                    src: _imports_0,
                                                    alt: "Modifica",
                                                    "on:hideImgUpload": hideImgUpload
                                                }, null, 32)
                                            ], 8, _hoisted_12),
                                            _createElementVNode("i", {
                                                class: "handle drag-img",
                                                style: { "cursor": "pointer" },
                                                role: "button",
                                                tabindex: "0",
                                                title: "Cancella",
                                                onClick: ($event) => (openModalDeleteOffer(element))
                                            }, [...(_cache[2] || (_cache[2] = [
                                                    _createElementVNode("img", {
                                                        src: _imports_1,
                                                        alt: "Cancella"
                                                    }, null, -1)
                                                ]))], 8, _hoisted_13),
                                            _cache[3] || (_cache[3] = _createElementVNode("i", {
                                                class: "handle drag-img",
                                                style: { "cursor": "grab" }
                                            }, [
                                                _createElementVNode("img", { src: _imports_2 })
                                            ], -1))
                                        ])
                                    ])
                                ]),
                                _: 1
                            }, 8, ["list"]))
                            : _createCommentVNode("", true)
                    ]))
            ]));
        };
    }
});
